import { useState } from "react";
import { Sparkles, ChevronDown, Linkedin } from "lucide-react";
import AtsGauge from "../app/AtsGauge";
import CompatibilityCard from "../app/CompatibilityCard";
import ShareWinModal from "../app/ShareWinModal";
import { StepNav } from "./Stepper";
import KeywordsAdded from "./KeywordsAdded";
import ToolsMatch from "./ToolsMatch";

export default function StepCompat({ app, onUpdate, onBack, onNext }) {
  const [jdOpen, setJdOpen] = useState(false);
  const [share, setShare] = useState(false);
  const compat = app.compatibility;
  return (
    <div className="af-fade-up space-y-5" data-testid="studio-step-compat">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-ink">How well you fit this job</h1>
        <p className="text-body mt-2">{app.role || "Role"} at {app.company || "the company"}</p>
      </div>
      <div className="grid lg:grid-cols-3 gap-5">
        <div className="gi-card p-6 flex flex-col items-center justify-center">
          <AtsGauge score={app.ats_score} label={compat ? "JOB MATCH" : "ATS MATCH"} />
          <p className="mt-3 text-sm text-faint text-center">An estimate, not a guarantee.</p>
          {app.ats_score >= 75 && (
            <button data-testid="share-score-button" onClick={() => setShare(true)} className="mt-3 gi-btn gi-btn-tertiary gi-btn-sm">
              <Linkedin className="w-4 h-4" /> Share on LinkedIn
            </button>
          )}
          <ShareWinModal open={share} onOpenChange={setShare} score={app.ats_score} kind="score" label={compat ? "Job match" : "ATS match"} />
        </div>
        <div className="lg:col-span-2 gi-card p-6">
          <div className="flex items-center gap-2 mb-2 text-brand"><Sparkles className="w-4 h-4" /><span className="text-sm font-semibold">In short</span></div>
          <p className="text-[15px] text-body leading-relaxed" data-testid="match-summary">{app.match_summary}</p>
        </div>
      </div>
      <ToolsMatch app={app} testid="compat-tools-match" />
      <KeywordsAdded app={app} testid="compat-keywords-added" />
      {compat && <CompatibilityCard app={app} compat={compat} pending={0} onChange={onUpdate} />}
      {app.jd_text && (
        <div className="gi-card p-5">
          <button onClick={() => setJdOpen((v) => !v)} data-testid="jd-toggle" aria-expanded={jdOpen} className="w-full flex items-center justify-between gap-3 text-left">
            <span className="font-semibold text-ink">The job ad</span>
            <ChevronDown className={`w-4 h-4 text-faint transition-transform ${jdOpen ? "rotate-180" : ""}`} />
          </button>
          {jdOpen && <div className="mt-4 max-h-72 overflow-y-auto rounded-xl bg-canvas border border-line p-4 text-[15px] text-body whitespace-pre-wrap leading-relaxed">{app.jd_text}</div>}
        </div>
      )}
      <StepNav onBack={onBack} onNext={onNext} nextLabel="Next: improve your CV" />
    </div>
  );
}
